module.exports = __webpack_public_path__ + "static/media/ph-logo.f6b2c62a.png";